// This file is auto-generated by @oracle/oraclejet-icu-l10n from src/resources/icu/bundle.json
// and should not be edited by hand. Update the JSON file and rerun the build to regenerate this content.

const bundle = {
  calendarDateConverter_parseError: (p: { dateExample: string }) =>
    'Versuchen Sie es erneut mit einem vollständigen Datum wie dem Folgenden: ' +
    p['dateExample'] +
    '.',
  chart_labelGroup: () => 'Gruppe',
  chart_labelSeries: () => 'Reihe',
  chart_labelValue: () => 'Wert',
  checkboxSet_requiredMessageDetail: () => 'Erforderlich',
  checkbox_requiredMessageDetail: () => 'Erforderlich',
  close: () => 'Schließen',
  collection_noData: () => 'Keine anzuzeigenden Daten.',
  collection_selectAllRows: () => 'Alle Zeilen auswählen',
  collection_selectRow: (p: { ROW_NAME: string }) => 'Zeile ' + p['ROW_NAME'] + ' auswählen',
  collection_sortDisabled: () => 'Nicht sortierbar',
  collection_sortEnabled: () => 'Sortierbar',
  confirmation: () => 'Bestätigung',
  dataVisualization_labelAndValue: (p: { LABEL: string; VALUE: string }) =>
    p['LABEL'] + ': ' + p['VALUE'],
  dataVisualization_labelCountWithTotal: (p: { itemCount: string; totalCount: string }) =>
    p['itemCount'] + ' von ' + p['totalCount'],
  dataVisualization_noData: () => 'Keine anzuzeigenden Daten',
  dataVisualization_stateSelected: () => 'Ausgewählt',
  dataVisualization_stateUnselected: () => 'Auswahl aufgehoben',
  error: () => 'Fehler',
  expandableList_expandCollapseInstructionText: () =>
    'Pfeiltasten zum Ein- und Ausblenden verwenden',
  expandableList_groupCollapse: () => 'Ausgeblendet',
  expandableList_groupExpand: () => 'Eingeblendet',
  filePicker_addFiles: () => 'Dateien hinzufügen',
  filePicker_dropzonePrimaryText: () => 'Drag-and-Drop',
  filePicker_dropzoneSecondaryText: () => 'Datei auswählen oder hier ablegen',
  filePicker_dropzoneSecondaryTextMultiple: () => 'Dateien auswählen oder hier ablegen',
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    'Sie können keine Dateien des folgenden Typs hochladen: ' + p['fileTypes'],
  filePicker_singleFileUploadError: () => 'Laden Sie jeweils nur eine Datei hoch',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    'Sie können keine Dateien des Typs ' + p['fileType'] + ' hochladen',
  filePicker_unknownFileTypeUploadError: () => 'unbekannt',
  formControl_clear: () => 'Leeren',
  formControl_day: () => 'Tag',
  formControl_helpAvailable: () => 'Hilfe verfügbar',
  formControl_limitReached: (p: { CHARACTER_LIMIT: number }) =>
    'Sie haben den Grenzwert von ' +
    (({ one: '1 Zeichen' } as Partial<Record<Intl.LDMLPluralRule, string>>)[
      new Intl.PluralRules('de').select(p['CHARACTER_LIMIT'])
    ] || new Intl.NumberFormat('de').format(p['CHARACTER_LIMIT']) + ' Zeichen') +
    ' erreicht.',
  formControl_loading: () => 'Wird geladen',
  formControl_maxLengthExceeded: (p: { MAX_LENGTH: string }) =>
    'Maximale Länge ' + p['MAX_LENGTH'] + ' überschritten.',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    p['CHARACTER_COUNT'] + ' Zeichen übrig.',
  formControl_month: () => 'Monat',
  formControl_readOnly: () => 'Schreibgeschützt',
  formControl_requiredMessageDetail: () => 'Geben Sie einen Wert ein.',
  formControl_year: () => 'Jahr',
  gantt_labelDate: () => 'Datum',
  gantt_labelEnd: () => 'Ende',
  gantt_labelLabel: () => 'Label',
  gantt_labelRow: () => 'Zeile',
  gantt_labelStart: () => 'Start',
  indexer_disabledLabel: (p: { SECTION: string }) =>
    p['SECTION'] + '. Kein übereinstimmender Abschnitt gefunden.',
  indexer_keyboardInstructionText: () => 'Drücken Sie die Eingabetaste, um einen Wert auszuwählen.',
  indexer_othersLabel: () => '#',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    'Zwischen ' + p['FROM_SECTION'] + ' und ' + p['TO_SECTION'] + '.',
  indexer_touchInstructionText: () =>
    'Doppeltippen und halten, um den Gestenmodus aufzurufen, und anschließend nach oben oder unten ziehen, um den Wert anzupassen.',
  info: () => 'Info',
  inputDateMask_date_cleared: () => 'Datum gelöscht',
  inputDateMask_dayPlaceholder: () => 'TT',
  inputDateMask_empty_segment: () => 'Leer',
  inputDateMask_monthPlaceholder: () => 'MM',
  inputDateMask_yearPlaceholder: () => 'JJJJ',
  inputNumber_converterParseError: () => 'Geben Sie eine Zahl ein.',
  inputNumber_decrease: () => 'Verringern',
  inputNumber_increase: () => 'Erhöhen',
  inputPassword_hidden: () => 'Kennwort ausgeblendet',
  inputPassword_hide: () => 'Kennwort ausblenden',
  inputPassword_show: () => 'Kennwort anzeigen',
  list_suggestion: () => 'Vorschlag',
  messageToast_allMessagesClosed: () => 'Alle Popup-Nachrichten sind geschlossen.',
  message_close: () => 'Schließen',
  message_confirmation: () => 'Erfolg',
  message_error: () => 'Fehler',
  message_info: () => 'Info',
  message_navigationFromMessagesRegion: () =>
    'Meldungsbereich wird geöffnet. Drücken Sie F6, um zum vorherigen fokussierten Element zurückzukehren.',
  message_navigationToMessagesRegion: () =>
    'Meldungsbereich enthält neue Meldungen. Drücken Sie F6, um zum aktuellen Meldungsbereich zu navigieren.',
  message_warning: () => 'Warnung',
  noData_message: () => 'Keine anzuzeigenden Elemente',
  overflowItemLabel: () => 'Weitere Registerkarten',
  plural_separator: () => ', ',
  progressIndeterminate: () => 'Wird ausgeführt',
  radio_helpForRadio: () => 'Hilfe für Optionsfeld',
  radio_requiredMessageDetail: () => 'Wählen Sie einen Wert.',
  selectMultiple_apply: () => 'Anwenden',
  selectMultiple_back: () => 'Zurück',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selectMultiple_removeSelectedTagInstructionText: () =>
    'Drücken Sie die Rücktaste oder ENTF, um den ausgewählten Wert zu entfernen.',
  selectMultiple_selectedValues: () => 'Ausgewählte Werte',
  selectMultiple_showSelectedValues: () => 'Nur ausgewählte Werte anzeigen.',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) =>
    p['VALUE_COUNT'] + ' Werte ausgewählt.',
  select_addToList: () => 'Zu Liste hinzufügen',
  select_addToListAvailable: () => '"Zu Liste hinzufügen" verfügbar',
  select_moreSearchOptions: () => 'Weitere Suchoptionen',
  select_moreSearchOptionsAvailable: () => 'Weitere Suchoptionen verfügbar',
  select_noMatchesFound: () => 'Keine Übereinstimmungen gefunden.',
  select_oneMatchFound: () => 'Eine Übereinstimmung gefunden',
  select_requiredMessageDetail: () => 'Wählen Sie einen Wert.',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) =>
    p['TOTAL_SIZE'] + ' Übereinstimmungen gefunden',
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    p['TOTAL_SIZE'] + ' oder mehr Übereinstimmungen gefunden',
  selector_selected: () => 'Kontrollkästchen aktiviert',
  selector_unselected: () => 'Kontrollkästchen nicht aktiviert',
  tabBarNavigationList_removeCueText: () => 'Kann entfernt werden',
  timeComponent_tooltipZoomIn: () => 'Vergrößern',
  timeComponent_tooltipZoomOut: () => 'Verkleinern',
  train_current: () => 'Aktuell',
  train_message_type: () => 'Meldungstyp',
  train_not_visited: () => 'Nicht besucht',
  train_status: (p: { currentStep: string; numberOfSteps: string }) =>
    'Schritt ' + p['currentStep'] + ' von ' + p['numberOfSteps'],
  train_visited: () => 'Besucht',
  userAssistance_learnMore: () => 'Weitere Informationen',
  userAssistance_required: () => 'Erforderlich',
  viz_drillable: () => 'Drillfähig',
  warn: () => 'Warnung'
};
export default bundle;
